/**************************************************************************************************/
/** @import Classes/Records                                                                      **/
/**************************************************************************************************/
import { ActionItem } from '@/Classes/Records/ActionItem'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Component } from '@/Constants/Component'

/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BMInterfaces } from '@/Helpers/Components/DataTable/BMInterfaces'

/**************************************************************************************************/
/** @export Class @name ActionField                                                              **/
/**************************************************************************************************/
export class ActionField
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	private itemIndex = -1
	public field = {} as BMInterfaces.FieldDefinition
	public items = [] as Array<BMInterfaces.ActionItemDefinition>

	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string)
	{
		this.field.key = key
		this.field.label = label
		this.setStyle(Component.VueComponents.Global.DataTable.DefaultThStyle)
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public addItem(key: string, type: 'button' | 'check' | 'icon') : this
	{
		this.itemIndex++
		this.items.push({ key, type })
		return this
	}

	public isDisabled() : this
	{
		const item = this.getCurrentItem()
		item.disabled = true
		return this
	}

	public isSortable() : this
	{
		this.field.sortable = true
		return this
	}

	private getCurrentItem() : BMInterfaces.ActionItemDefinition
	{
		return this.items[this.itemIndex]
	}

	public on(name: string, callback: (item: any) => (ActionItem | void)) : this
	{
		this.itemIndex++
		this.items.push({} as any)
		this.items[this.itemIndex][name] = callback
		return this
	}

	public setColor(fieldName: string, from: any) : this
	{
		const item = this.getCurrentItem()
		item.$colorBy = fieldName
		item.$colorFrom = from
		return this
	}

	public setEnumerable(fieldName: string, from: any) : this
	{
		const item = this.getCurrentItem()
		item.enumBy = fieldName
		item.enumFrom = from
		return this
	}

	public setIcon(icon: string | [string, string]) : this
	{
		const item = this.getCurrentItem()
		item.icon = icon
		return this
	}

	public setPermission(key: string) : this
	{
		const item = this.getCurrentItem()
		item.permission = key
		return this
	}

	public setSort(...sortBy: Array<[string, string]>) : this
	{
		const item = this.getCurrentItem()
		item.sortBy = []
		for (const s of sortBy) item.sortBy.push({ key: s[0], from: s[1] })
		return this
	}

	public setStyle(style: BMInterfaces.FieldDefinition['thStyle']) : this
	{
		this.field.thStyle = style
		return this
	}

	public setText(text: string) : this
	{
		const item = this.getCurrentItem()
		item.text = text
		return this
	}

	public setTextFrom(fieldName: string) : this
	{
		const item = this.getCurrentItem()
		item.$textFrom = fieldName
		return this
	}

	public setTitle(title: string) : this
	{
		const item = this.getCurrentItem()
		item.title = title
		return this
	}

	public setType(type: 'normal' | 'switch' = 'normal') : this
	{
		const item = this.getCurrentItem()
		item.checkType = type
		return this
	}

	public setVariant(variant: string) : this
	{
		const item = this.getCurrentItem()
		item.variant = variant
		return this
	}
}